"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDropdownButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Chevron_1 = require("../../atoms/Chevron/Chevron");
var Icon_1 = require("../../atoms/Icon/Icon");
var Typography_1 = require("../../atoms/Typography/Typography");
var FilterDropdownButton_style_1 = __importDefault(require("./FilterDropdownButton.style"));
/**
 * FilterDropdownButton molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-filterdropdownbutton--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/FilterDropdownButton Source}
 */
var FilterDropdownButton = function (_a) {
    var className = _a.className, pathProps = _a.pathProps, title = _a.title, selectedItemsText = _a.selectedItemsText, onClick = _a.onClick, onMouseDown = _a.onMouseDown, isExpanded = _a.isExpanded;
    var classes = (0, FilterDropdownButton_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: onClick, onMouseDown: onMouseDown, className: (0, classnames_1.default)(classes.root, className) }, { children: [pathProps && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: pathProps, color: theme_1.default.textColors.primary, "data-testid": 'filter-dropdown-button-icon' })), (0, jsx_runtime_1.jsxs)(Typography_1.Typography, __assign({ className: pathProps ? classes.title : classes.titleWithoutMarginLeft, variant: 'label1', noWrap: true, color: theme_1.default.textColors.primary, bold: true }, { children: [title, selectedItemsText && ':'] })), selectedItemsText && renderSelectedItemsText(), (0, jsx_runtime_1.jsx)(Chevron_1.Chevron, { isExpanded: isExpanded, className: classes.chevron, color: theme_1.default.textColors.primary, height: 10, width: 14 })] })));
    function renderSelectedItemsText() {
        return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'label1', noWrap: true, color: theme_1.default.textColors.highlight, bold: true }, { children: selectedItemsText })));
    }
};
exports.FilterDropdownButton = FilterDropdownButton;
